import { render, staticRenderFns } from "./statisticsOverdue.vue?vue&type=template&id=3617c6d6&scoped=true&"
import script from "./statisticsOverdue.vue?vue&type=script&lang=js&"
export * from "./statisticsOverdue.vue?vue&type=script&lang=js&"
import style0 from "./statisticsOverdue.vue?vue&type=style&index=0&id=3617c6d6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3617c6d6",
  null
  
)

export default component.exports